import useWindowSize from 'components/util/useWindowSize'
import LeftRobotCard from 'components/cards/new/common/LeftRobotCard'
import CircleCheck from 'components/icons/CircleCheck'
import { Button } from 'components/forms/Button'
import Link from 'next/link'

const reasons = [
  'Operates from Sydney CBD',
  '99.99% uptime',
  'Local support during AEST hours',
  'Digital-first and scalable',
  'Fully compliant with AU KYC/AML regulations',
]

const WhyAusBusinessChooseUs = () => {
  const size = useWindowSize()

  return (
    <LeftRobotCard
      image={{
        alt: 'Robot arm with mail envelope',
        desktop: {
          dimensions: {
            height: 820,
            width: 582,
          },
          src: '/images/new/au/robot-arm-mail-zoomed.png',
        },
        mobile: {
          dimensions: {
            height: 1122,
            width: 696,
          },
          src: '/images/new/robot-arm-mail.png',
        },
      }}
      imageContainerWidth={size.isLgOrHigher ? '45%' : '100%'}
      imageStyle={{
        objectFit: 'cover',
        objectPosition: 'right top',
        width: '100%',
      }}
    >
      <div className='d-flex flex-1 flex-column gap-4 px-4 pt-4 pb-5 pb-lg-10 pe-lg-8 pt-lg-22 mt-lg-0 mt-n16'>
        <h3
          className='fw-semibold fs-fluid-48-80 lh-105'
          style={{
            maxWidth: 545,
          }}
        >
          Why Australian Businesses{' '}
          <span className='color-pink2'>Choose Us</span>
        </h3>
        <ul className='list-unstyled d-flex flex-column gap-4'>
          {reasons.map((reason, index) => (
            <li
              key={index}
              className='fs-fluid-18-26 fw-semibold lh-134 d-flex'
            >
              <CircleCheck
                fill='#30DB5B'
                className='me-2 mt-lg-2 flex-shrink-0 mt-1'
              />
              <span>{reason}</span>
            </li>
          ))}
        </ul>
        <Link
          className='align-self-lg-end w-full w-lg-auto'
          href={'/au/enterprise#konnect-form'}
        >
          <Button className='w-100'>Book a Demo</Button>
        </Link>
      </div>
    </LeftRobotCard>
  )
}

export default WhyAusBusinessChooseUs
